


















































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ItemAtendimento from "@/views/private/cadastros/saude/atendimento/ItemAtendimento.vue";
import DadosTitular from "./componentes/DadosTitular.vue";
import DadosPaciente from "./componentes/DadosPaciente.vue";
import DadosAtendimento from "./componentes/DadosAtendimento.vue";
import DadosSolicitacao from "./componentes/DadosSolicitacao.vue";
import DadosAnaliseSolicitacao from "./componentes/DadosAnaliseSolicitacao.vue";
import Orcamento from "./Orcamento.vue";
import DadosGlosa from "./componentes/DadosGlosa.vue";
import DadosPagamento from "./componentes/DadosPagamento.vue";
import ModalAprovarRecusarSolicitacao from "./componentes/ModalAprovarRecusarSolicitacao.vue";
import ModalAprovarRecusarValorAdicional from "./componentes/ModalAprovarRecusarValorAdicional.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import DetalheAtendimentoModel from "@/models/cadastros/saude/DetalheAtendimentoModel";
import { statusAtendimento } from "@/models/cadastros/saude/StatusAtendimentoModel";
import { tiposAtendimentoList } from "@/models/cadastros/saude/TipoAtendimentoModel";
import { tiposRamoList } from "@/models/cadastros/saude/RamoModel";
import { saudeAtendimentoService } from "@/service/cadastro/saude/atendimento/SaudeAtendimentoService";
//@ts-ignore
import moment from "moment";
import { tiposTelefoneList } from "@/models/commons/TelefoneModel";
import { estadosList } from "@/models/commons/EstadoModel";
import { OrcamentoModel } from "@/models/cadastros/saude/atendimento/orcamento/OrcamentoModel";
import EspecialidadeModel from '@/models/cadastros/saude/EspecialidadeModel';

@Component({
  components: {
    ItemAtendimento,
    DadosTitular,
    DadosPaciente,
    DadosAtendimento,
    DadosSolicitacao,
    DadosAnaliseSolicitacao,
    DadosPagamento,
    Orcamento,
    DadosGlosa,
    ModalAprovarRecusarSolicitacao,
    ModalAprovarRecusarValorAdicional,
    GsModalDialog,
  },
})
export default class DetalheAtendimento extends Vue {
  detalhe: DetalheAtendimentoModel = this.detalheDefault();

  tiposRamo = tiposRamoList;
  tiposTelefone = tiposTelefoneList;
  tiposAtendimento = tiposAtendimentoList;
  status = statusAtendimento;
  estados = estadosList;
  mensagemPagamento: string = "";

  tipoModalAprovarRecusarSolicitacao = "RECUSA";
  exibeModalAprovarRecusarSolicitacao = false;

  tipoModalAprovarRecusarValorAdicional = "RECUSA";
  exibeModalAprovarRecusarValorAdicional = false;

  orcamento: OrcamentoModel = {
    valorPrestador: "0,00",
    valorAdicionalEstimado: "0,00",
    valorAssociado: "0,00",
    descricao: "",
    dataAgendamento: "",
    horaAgendamento: "",
  };

  /* MODAL */
  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  especialidades: EspecialidadeModel[] = [];
  especialidade: EspecialidadeModel = {};

  closeDialog() {
    if (this.successDialog) {
      this.loadingDetalhe();
    }
    this.showDialog = false;
  }

  openDialog(params: any) {
    this.successDialog = params.sucesso;
    this.dialogTitle = params.sucesso ? "Sucesso" : "Erro";
    this.dialogMessage = params.mensagem;
    this.showDialog = true;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }

  @Watch("detalhe")
  pagamentoWatch() {
    this.detalhe?.pagamentoRealizado
      ? (this.mensagemPagamento = "Pagamento realizado")
      : (this.mensagemPagamento = "Pagamento não realizado");
  }

  get mensagemAgendamento(): string {
    if (!!this.detalhe.dataAgendamento && !!this.detalhe.horaAgendamento) {
      const dataHora = moment(this.detalhe.dataAgendamento + " " + this.detalhe.horaAgendamento);
      return `Data e hora do agendamento: ${dataHora.format("DD/MM/YYYY ")} às ${dataHora.format("HH:mm")}`;
    } else if (this.detalhe.statusAtendimento?.name === "DESMARCADO") {
      return "O atendimento doi desmarcado, aguardando nova data de agendamento.";
    } else {
      return "Agendamento realizado diretamente com o local de atendimento";
    }
  }

  get emAnalise() {
    return this.detalhe?.statusAtendimento?.name == "ORCAMENTO_SOLICITADO";
  }

  get emOrcamentacao() {
    return this.detalhe?.statusAtendimento?.name == "EM_ORCAMENTACAO";
  }

  get possuiOrcamento() {
    return !!this.orcamento.descricao;
  }

  get possuiValorAdicional() {
    return this.detalhe?.historicosAtendimento && this.detalhe?.historicosAtendimento.length > 0;
  }

  get emAnaliseGlosa() {
    return this.detalhe?.statusAtendimento?.name == "EM_APROVACAO_VALOR_ADICIONAL";
  }

  get idAtendimento() {
    return this.$route.params.idAtendimento;
  }

  mounted() {
    if (!this.$route.params.idAtendimento) {
      this.fechar();
    }
    this.loadingDetalhe();
  }

  fechar() {
    this.$router.push({
      name: "ListaAtendimentos",
    });
  }

  recusarSolicitacao() {
    this.tipoModalAprovarRecusarSolicitacao = "RECUSA";
    this.exibeModalAprovarRecusarSolicitacao = true;
  }

  aprovarSolicitacao() {
    if(this.detalhe.tipoAtendimentoItegracao == "REMOCAO") {
      saudeAtendimentoService.pesquisarEspecialidadesRemocao(this.detalhe.remocao?.cidade?.id || -1, this.detalhe.ramoAtendimento || "", this.detalhe.tipoAtendimentoItegracao)
      .then((especialidades: EspecialidadeModel[]) =>  {
        this.especialidades = especialidades;
        this.especialidade = especialidades.find(esp => esp.id === this.detalhe.idEspecialidade) || {};
        this.tipoModalAprovarRecusarSolicitacao = "APROVACAO";
        this.exibeModalAprovarRecusarSolicitacao = true;
      });
    } else {
      
        this.tipoModalAprovarRecusarSolicitacao = "APROVACAO";
        this.exibeModalAprovarRecusarSolicitacao = true;
    }
  }

  incluirOrcamento() {
    this.$router.push({
      name: "IncluirOrcamento",
      params: {
        idAtendimento: this.$route.params.idAtendimento,
      },
    });
  }
  efetivarAnaliseValorAdicional(tipoAnalise: string) {
    this.tipoModalAprovarRecusarValorAdicional = tipoAnalise;
    this.exibeModalAprovarRecusarValorAdicional = true;
  }

  detalheDefault() {
    return {
      id: undefined,
      idCidadeSolicitacao: -1,
      atendimento: "",
      numeroAtendimento: "",
      tipoAtendimento: "",
      especialidade: "",
      valorAssociado: undefined,
      valorPrestador: undefined,
      dataAgendamento: "",
      horaAgendamento: "",
      prestador: {
        nome: "",
        cnpj: "",
      },
      titular: {
        nome: "",
        cpf: "",
        cidade: "",
        estado: "",
        telefones: [],
      },
      paciente: {
        nome: "",
        dataNascimento: "",
        cpf: "",
      },
      pagamentoRealizado: false,
      pedidosMedicos: [],
    };
  }

  loadingDetalhe() {
    if (this.$route.params.idAtendimento) {
      saudeAtendimentoService.obterDetalheAtendimento(Number(this.$route.params.idAtendimento)).then((res) => {
        this.detalhe = {
          id: Number(this.$route.params.idAtendimento),
          atendimento: this.tiposRamo.find((ramo) => ramo.name == res?.especialidade?.ramo)?.descricao,
          ramoAtendimento: res?.especialidade?.ramo,
          numeroAtendimento: res?.numeroAtendimento,
          statusAtendimento: this.status.find((status) => status.name == res?.status),
          tipoAtendimento: this.tiposAtendimento.find((tipo) => tipo.name == res?.especialidade?.tipoAtendimento)?.descricao,
          tipoAtendimentoItegracao: res?.especialidade?.tipoAtendimento,
          especialidade: res?.especialidade?.nome,
          idEspecialidade: res?.especialidade?.id,
          idPagamentoCliente: res?.idPagamentoCliente,
          tentativasDePagamentoDoValorAdicional: res?.tentativasDePagamentoDoValorAdicional,
          dataUltimaAtualizacao: res?.dataUltimaAtualizacao,
          valorAssociado: res?.precoAssociado ? res?.precoAssociado.toFixed(2) : "",
          valorPrestador: res?.precoPrestador ? res?.precoPrestador.toFixed(2) : "",
          valorAdicional: res?.valorAdicional ? res?.valorAdicional.toFixed(2) : 0,
          dataAgendamento: res?.data,
          horaAgendamento: res?.hora,
          prestador: {
            nome: res?.prestador?.nome,
            cpfCnpj: res?.prestador?.cpfCnpj,
            endereco: {
              cep: res?.prestador?.endereco?.cep,
              logradouro: res?.prestador?.endereco?.logradouro,
              numero: res?.prestador?.endereco?.numero,
              complemento: res?.prestador?.endereco?.complemento,
              cidade: res?.prestador?.endereco?.cidade,
              bairro: res?.prestador?.endereco?.bairro,
            },
            telefones: res?.prestador?.telefones,
            profissional: {
              nome: res?.profissional?.nome,
              numeroRegistro: res?.profissional?.numeroRegistro,
            },
          },
          titular: {
            nome: res?.cliente.nome,
            cpfCnpj: res?.cliente.cpfCnpj,
            cidade: res?.cliente?.endereco?.cidade,
            estado: this.estados.find((estado) => estado?.sigla == res?.cliente?.endereco?.estado)?.nome,
            telefones: res?.cliente?.telefones,
          },
          paciente: {
            nome: res?.nomePaciente,
            dataNascimento: res?.dataNascimentoPaciente,
            cpf: res?.cpfPaciente,
          },
          pagamentoRealizado: res?.pagamentoRealizado,
          pedidosMedicos: res?.pedidosMedicos,
          dataContratacao: res?.dataContratacao,
        };
        if (res?.remocao) {
          this.detalhe.remocao = {
            trajeto: res?.remocao.trajeto,
            origem: Object.assign({}, res?.remocao.enderecoOrigemRemocao),
            destino: Object.assign({}, res?.remocao.enderecoDestinoRemocao),
            cidade: {
              id: res.remocao.cidadeSolicitacao.id,
              nome: res.remocao.cidadeSolicitacao.nome,
              estado: estadosList.find(e => e.sigla === res.remocao.cidadeSolicitacao.estado)
            }
          };
        }
        this.detalhe.analiseSolicitacao = res.analiseSolicitacao;
        this.detalhe.dataPrevistaRetorno = res.dataPrevistaRetorno;
        this.detalhe.nomeResponsavel = res.nomeResponsavel;

        if (res.orcamento) {
          this.orcamento = Object.assign({}, res.orcamento);
          this.orcamento.dataAgendamento = res.orcamento.dataAtendimento;
          this.orcamento.horaAgendamento = res.orcamento.horaAtendimento;
          this.orcamento.valorAdicionalEstimado = res.orcamento.estimativaValorAdicional;
        }
        if(res.historicosAtendimento) {
          this.detalhe.historicosAtendimento = res.historicosAtendimento.map((historico: any) => {
            return {
              id: historico.id,
              nome: historico.nome,
              dataCriacao: historico.dataCriacao,
              justificativa: historico.justificativa,
              arquivos: historico.arquivos
            }
          });
        } else {
          this.detalhe.historicosAtendimento = [];
        }
      });
    }
  }
}
